












































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Contacts extends Vue { 
    @Prop(Object) readonly tableItem: any
    @Prop(String) readonly cloumnName: any
    @Prop(Function) public notifcation: any
	@Prop() public trackid: any

	monthText = ['มกราคม','กุมภาพันธ์', 'มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']
    menu = false

	get dateText() {
		if (this.tableItem[`${this.cloumnName}`]) {
			const [year, month, day] = this.tableItem[`${this.cloumnName}`].split("-")
			return `${day}/${month}/${year}`
		}
		return this.tableItem[`${this.cloumnName}`]
    }

	set dateText (newValue: any) {
		this.tableItem[`${this.cloumnName}`] = newValue === null ? "" : newValue
	}

	setYear (date: string){
		return date.substring(0, 4)
	}

	setHeaderDate (date: string) {
		const splitDate: any[] = date.split("-")
		const myText = `${this.monthText[splitDate[1]-1] === undefined ? '' : this.monthText[splitDate[1]-1]} ${date.substring(0, 4)}`
		return myText
	}

	validate () {
		this.menu = true
		const columnInspection1Alert = ["inspection1FinishPJDate", "inspection1PlanCRDate", "inspection1CustomerDate"]
		if (columnInspection1Alert.includes(this.cloumnName)) {
			if (this.tableItem.inspection1PlanPJDate === '') {
				this.notifcation('กรุณากรอก Plan PJ พร้อมให้เข้าตรวจ #1', "warning")
				this.menu = false
				return
			}
		}
		const columnInspection2Alert = ["inspection2FinishPJDate", "inspection2PlanCRDate", "inspection2CustomerDate"]
		if (columnInspection2Alert.includes(this.cloumnName)) {
			if (this.tableItem.inspection2PlanPJDate === '') {
				this.menu = false
				this.notifcation('กรุณากรอก Plan PJ พร้อมให้เข้าตรวจ #2', "warning")
				return
			}
		}
		const columnInspection3Alert = ["inspection3FinishPJDate", "inspection3PlanCRDate", "inspection3CustomerDate"]
		if (columnInspection3Alert.includes(this.cloumnName)) {
			if (this.tableItem.inspection3PlanPJDate === '') {
				this.menu = false
				this.notifcation('กรุณากรอก Plan PJ พร้อมให้เข้าตรวจ #3', "warning")
				this.dateText = null
				return
			}
		}
		const columnInspection4Alert = ["inspection4FinishPJDate", "inspection4PlanCRDate", "inspection4CustomerDate"]
		if (columnInspection4Alert.includes(this.cloumnName)) {
			if (this.tableItem.inspection4PlanPJDate === '') {
				this.menu = false
				this.notifcation('กรุณากรอก Plan PJ พร้อมให้เข้าตรวจ #4', "warning")
				return
			}
		}
	}
}
